import { buildDerivedSiteContext, RequestServerContext, Site } from './site-context'

const cache: { site: Site; context: ReturnType<typeof buildDerivedSiteContext> }[] = []

export const buildCachedDerivedData = (context: RequestServerContext) => {
  const hit = cache.find(
    x => x.site === context.site && x.context.deviceType === context.deviceType
  )
  if (hit) {
    return hit.context
  }

  const derivedData = buildDerivedSiteContext(context)
  cache.push({ site: context.site, context: derivedData })

  return derivedData
}
